import {
  SET_GC_PHASE,
  SET_GC_FIELD,
  SET_GC_FORM,
  SET_GC_LOADING,
  SET_GC_ERROR,
  SET_GC_FIELD_ERROR,
  CLEAR_GC_FIELD_ERRORS,
  SET_GC_ACTIVATION,
  RESET_GC,
} from "./mutation-types";

export default {
  [SET_GC_PHASE](state, phase) {
    state.appPhase = phase;
  },

  [SET_GC_FIELD](state, { key, value }) {
    state.form[key] = value;
  },

  [SET_GC_FORM](state, partial) {
    state.form = { ...state.form, ...partial };
  },

  [SET_GC_LOADING](state, { key, value }) {
    state.loading[key] = value;
  },

  [SET_GC_ERROR](state, { key, message }) {
    state.errors[key] = message;
  },

  [SET_GC_FIELD_ERROR](state, { field, message }) {
    state.errors.fields = { ...state.errors.fields, [field]: message };
  },

  [CLEAR_GC_FIELD_ERRORS](state) {
    state.errors.fields = {};
  },

  [SET_GC_ACTIVATION](state, activation) {
    state.activation = activation;
  },

  [RESET_GC](state) {
    state.appPhase = "identity";
    state.form = {
      civility: "",
      firstName: "",
      lastName: "",
      phoneDial: "+225",
      phoneNumber: "",
      waDial: "+225",
      waNumber: "",
      sameAsWhatsapp: true,
      hasAuto: null,
      autoExpiryDate: "",
      hasHome: null,
      homeExpiryDate: "",
      eventCode: "default",
    };
    state.activation = null;
    state.loading = { submit: false };
    state.errors = { submit: "", fields: {} };
  },
};
